import {
  inboundShipmentIdFormat,
  productIdFormat,
  purchaseOrderIdFormat,
} from "@redotech/redo-ids/ids";
import * as z from "zod";

const ShipmentProductAssignmentSchema_ = z.object({
  shipmentId: inboundShipmentIdFormat.schema,
  productId: productIdFormat.schema,
  quantity: z.number().int(),
});

export const ShipmentProductAssignmentSchema: z.ZodType<ShipmentProductAssignment> =
  ShipmentProductAssignmentSchema_;
export interface ShipmentProductAssignment
  extends z.infer<typeof ShipmentProductAssignmentSchema_> {}

export const updateShipmentProducts = {
  name: "updateShipmentProducts" as const,
  input: z.object({
    purchaseOrderId: purchaseOrderIdFormat.schema,
    assignments: z.array(ShipmentProductAssignmentSchema),
    editedShipmentIds: z.array(inboundShipmentIdFormat.schema),
  }),
  output: z.object({ success: z.boolean() }),
};
